

export enum NewEventName {
    menuVisit = 'MenuVisit',
    cart = 'Cart',
    orderPaid = 'OrderPaid',
    checkout = 'Checkout',
    orderCreated = 'orderCreated'
}
export enum EventType {
    conversion = 'conversion',
    numeric = 'numeric'
}


export interface LocalizedString {
    [s: string]: string | undefined
}
